import React, { useState, useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import Paging from "../../components/includes/Paging";
import AnalysisSearch from "../../components/analysis/AnalysisSearch";
import AnalysisSearchResult from "../../components/analysis/AnalysisSearchResult";
import {LoginAfterCheckLogin,ChangeSimpleDateString,PassedMonths} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";


//학부모/원생관리
const AnalysisList = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
      {Header:'번호',accessor:'nums',width:50},
      {Header:'센터명',accessor:'bh_company',width:120},
      {Header:'원생명',accessor:'ch_name',width:90},
      {Header:'개월',accessor:'ch_month',width:70},
      {Header:'생년월일',accessor:'ch_birthday',width:100},
      {Header:'평가구분',accessor:'evaluation',width:120},
      {Header:'학기 클래스',accessor:'semester_class',width:200},
      {Header:'진행차수/수업차수',accessor:'studies',width:70},
      {Header:'평가일',accessor:'evaluation_date',width:90},
      {Header:'클래스고유번호',accessor:'cl_idx',width:20},
      {Header:'클래스 종류',accessor:'cl_type',width:20},
      {Header:'원생고유번호',accessor:'ch_idx',width:20}
  ];
  const [varColumnLists,setColumnLists] = useState([]);

  //수강 목록
  const [varAnalysisLists,setAnalysisLists] = useState([]);
  //센터 목록
  const [varBranchList,setBranchList] = useState([]);
  //검색년도
  const [varYearList, setYearList] = useState([]);
  //검색월
  const [varMonthList, setMonthList] = useState([]);
  
  //검색
  const [varSearchData, setSearchData] = useState({
    searchBranch:0,
    searchSemester:0,
    searchYear:0,
    searchMonth:0,
    searchOption:'all',
    searchString:''
  });

  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  
  //학부모/원생 목록 읽어오기
  const getAnalysisList = async () => {
    const sendData = {pageNum: varPageNum,pageSize: varPageSize,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_classes_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        let newArray = [];
        const pmax = datas.totalcount - (varPageNum - 1) * varPageSize;
        if(pmax > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_company'] = lineObj.bh_company;
            newData['ch_name'] = lineObj.ch_name;
            newData['ch_month'] = PassedMonths(lineObj.ch_birthday)+" 개월";
            newData['ch_birthday'] = ChangeSimpleDateString(lineObj.ch_birthday);
            newData['evaluation'] = lineObj.cl_type===1?"마마몽떼":"플라이";
            newData['semester_class'] = lineObj.sm_name+' '+lineObj.cl_name;
            newData['studies'] = (lineObj.pass_cnt)+'/'+lineObj.tstudys;
            newData['evaluation_date'] = ChangeSimpleDateString(lineObj.clc_adate);
            newData['cl_idx'] = lineObj.cl_idx;
            newData['ch_idx'] = lineObj.ch_idx;
            newData['cl_type'] = lineObj.cl_type;
            newArray.push(newData);
          }
        }
        console.log(newArray);
        setAnalysisLists(newArray);
        setBranchList(datas.branchs);
      } else {
        setAnalysisLists([]);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'ANALYSIS',item:'Analysis'});
    console.log(varAdminMenus);
    setColumnLists(columnList);
    const ndate = new Date();
    //년도배열
    const nYear = ndate.getFullYear();
    let ayears = [];
    for(var i=0; i <10; i++) {
      ayears.push(nYear-i);
    }
    setYearList(ayears);
    //월배열
    let amonth = [];
    for(var j=1; j <12; j++) {
      amonth.push(j);
    }
    setMonthList(amonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAnalysisList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  return varColumnLists.length===0?null:(
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={"발달분석 및 평가"} varDirection={'발달분석 및 평가'}/>
      <div className="admin-content">
        <AnalysisSearch varSearchData={varSearchData} setSearchData={setSearchData} setPageNum={setPageNum} 
              varBranchList={varBranchList} varYearList={varYearList} varMonthList={varMonthList}/>
        <AnalysisSearchResult varTotalCount={varTotalCount} varColumnLists={varColumnLists} varAnalysisLists={varAnalysisLists} varSearchData={varSearchData}/>
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
        </div>
      </div>
    </div>
  );
}
export default AnalysisList;